"use strict";

var debug = require("debug")("knack.formatter.formatters.email");

/**
 * @alias "formatters.email"
 * @param {Object} value
 * @param {String} value.email
 * @param {String} [value.label] With `emailFormat.text_format` == 'unique', the anchor tag willi show `value.label` rather than `value.email`
 * @param {Object} [emailFormat]
 * @param {String} [emailFormat.text_format]
 * @param {String} [format] 'text' to return value.email, anything returns html tag
 * @return {String}
 */
var emailFormatter = function emailFormatter(value, emailFormat, format) {
  if (!value || !value.email) {
    return "";
  }
  if (format === "text") {
    return value.email;
  }
  emailFormat = emailFormat || {
    text_format: "url"
  };
  var email = "<a href=\"mailto:".concat(value.email, "\">");
  switch (emailFormat.text_format) {
    case "same":
      email += emailFormat.label;
      break;
    case "unique":
      email += value.label ? value.label : value.email;
      break;
    default:
      email += value.email;
      break;
  }
  email += "</a>";
  return email;
};
module.exports = emailFormatter;